module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hCNwK"))).then(() => parcelRequire('iDabs'));